import { useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { SheetBody } from '@/components/custom/sheet-layout';
import { PatientDetail, type PatientTab } from './PatientDetailPage';

/**
 * The patient page in a slide-over, over the page it was opened from. Which
 * patient is open is the host's to keep (in its URL); the tab is local, and
 * starts on Information each time.
 */
export function PatientSheet({
  patientId,
  onClose,
}: {
  /** The sheet is open while there is one. */
  patientId: string | undefined;
  onClose: () => void;
}): React.ReactElement {
  return (
    <Sheet open={!!patientId} onOpenChange={(next) => !next && onClose()}>
      {/* `pt-8` drops the page below the sheet's corner X, which otherwise sits
          on the patient's actions menu at the top right. */}
      <SheetContent className="w-full gap-0 pt-8 sm:max-w-5xl">
        <SheetHeader className="sr-only">
          <SheetTitle>Patient details</SheetTitle>
        </SheetHeader>
        {/* Keyed so another patient opens on its first tab. */}
        <SheetBody className="px-0 pb-0">
          {patientId && <PatientSheetBody key={patientId} patientId={patientId} />}
        </SheetBody>
      </SheetContent>
    </Sheet>
  );
}

function PatientSheetBody({ patientId }: { patientId: string }): React.ReactElement {
  const [tab, setTab] = useState<PatientTab>('information');
  return <PatientDetail patientId={patientId} tab={tab} onTabChange={setTab} showBack={false} />;
}
